<template>
    <v-dialog v-model="isShow" kind="modal" class="role-select-panel" @confirm="confirmClick" @cancel="cancelClick" :title="title" :width="700" confirmText="保存">
        <role-select v-bind="$attrs" @change="change"></role-select>
        <v-dialog
            v-model="showConfrimDlg"
            @confirm="confirm"
            kind="confirm"
        >
            <div
                slot="title"
                :style="{fontWeight: 500, fontSize: '16px'}"
            >
                系统超级管理员拥有企业全部权限，仅一人可被<br>赋予该角色，更换或移除只能由本人或企业管理<br>员处理，请谨慎操作
            </div>
            <span slot="confirm-text">确认添加</span>
        </v-dialog>
    </v-dialog>
</template>
<script>
import RoleSelect from '../role-select';

export default {
    components: {
        RoleSelect
    },

    props: {
        value: {
            type: Boolean,
            default: false
        },

        title: {
            type: String,
            default: '添加角色'
        }
    },

    data() {
        return {
            checkedItemArr: [],
            showConfrimDlg: false,
        };
    },

    computed: {
        isShow: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },

    methods: {
        change(checkedItemArr) {
            this.checkedItemArr = checkedItemArr;
        },

        confirmClick() {
            const hasAdminRole = this.checkedItemArr.filter(item => item.newChecked);
            if (hasAdminRole.length) {
                this.showConfrimDlg = true;
            } else {
                this.$emit('confirm', this.checkedItemArr);
                this.isShow = false;
            }
        },
        confirm() {
            this.$emit('confirm', this.checkedItemArr);
            this.isShow = false;
        },
        cancelClick() {
            this.$emit('cancel', this.checkedItemArr);
            this.isShow = false;
        }
    }
};
</script>

<style lang="less">
@import './index.less';
</style>
